import { connect } from 'react-redux';
import ZonesContainer from './ZonesContainer';

// selectors
import {
  canChooseSeedProduct,
  getActiveScript,
  getActiveScriptWithZonesProperties,
  getActiveZoneId,
  usingLiquidIsChecked
} from 'current/selectors';
  
  
import {
  getScriptTypeForScript,
  scriptTypeIsNitrogen as scriptTypeIsNitrogenFunc
} from 'scripts/selectors';
  
import {
  hasFertilizerApplicationsForZones
} from 'scripts/zones/fertility-selectors';
import { getFormatFromZones } from 'products/selectors';
import { isGenerateZonesScript } from 'manual/selectors';
import { isZoneHistoryInOriginalState } from 'scripts/drawing-history/selectors';

export default connect(
  (state, ownProps) => {
    const { zoneRef } = ownProps;
    const script = getActiveScript(state);
    const { zones } = script;
    const canSortZonesByProperties = isGenerateZonesScript(state) && isZoneHistoryInOriginalState(script);

    const format = getFormatFromZones(zones);
    return {
      activeZoneId: getActiveZoneId(state),
      canChooseSeedProduct: canChooseSeedProduct(state),
      canSortZonesByProperties,
      fertilizerFormat: format,
      script: canSortZonesByProperties ? getActiveScriptWithZonesProperties(state) : getActiveScript(state),
      scriptType: getScriptTypeForScript(script),
      scriptTypeIsNitrogen: scriptTypeIsNitrogenFunc(script),
      showLiquidApplication: hasFertilizerApplicationsForZones(zones) || usingLiquidIsChecked(state),
      zoneRef
    };
  }
)(ZonesContainer);
